module.exports = __webpack_public_path__ + "od-arrow-left-grey-icon/od-arrow-left-grey-icon-975c6e6b670a78a8aade7acee1fe0ca2.svg";